let defaultcity = '北京'
try {
  if (localStorage.city) {
    defaultcity = localStorage.city
  }
} catch (e) {}
export default {
  city: defaultcity
}



// WEBPACK FOOTER //
// ./src/store/state.js